/**
 * More payment options → checkout.
 * If cart is empty, add the current product form line first, then redirect.
 */
function getProductForm(trigger) {
  const block = trigger.closest('.buy-buttons-block');
  return (
    block?.querySelector('product-form-component form[data-type="add-to-cart-form"]') ||
    document.querySelector('product-form-component form[data-type="add-to-cart-form"]')
  );
}

async function getCartItemCount() {
  const response = await fetch(`${window.Theme?.routes?.cart_url || '/cart'}.js`, {
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error('Could not load cart');
  const cart = await response.json();
  return Number(cart.item_count) || 0;
}

async function addCurrentProduct(form) {
  const formData = new FormData(form);
  const addUrl = window.Theme?.routes?.cart_add_url || '/cart/add.js';
  const atcToken = window.__dcodedLlpIssueAtcToken?.();
  const headers = { Accept: 'application/json' };

  // The site-wide add guard requires a token for direct PDP cart requests.
  if (atcToken) {
    headers['X-Dcoded-Llp-Atc'] = '1';
    headers['X-Dcoded-Llp-Atc-Token'] = atcToken;
  }

  const response = await fetch(addUrl, {
    method: 'POST',
    headers,
    body: formData,
  });

  const data = await response.json();
  if (data.status && data.message) {
    throw new Error(data.description || data.message);
  }
}

function goToCheckout() {
  window.location.href = '/checkout';
}

async function handleMorePaymentClick(event) {
  const trigger = event.currentTarget;
  if (!(trigger instanceof HTMLElement)) return;

  event.preventDefault();
  if (trigger.getAttribute('aria-busy') === 'true') return;

  const form = getProductForm(trigger);
  if (!(form instanceof HTMLFormElement)) {
    goToCheckout();
    return;
  }

  trigger.setAttribute('aria-busy', 'true');
  trigger.classList.add('is-loading');

  try {
    const itemCount = await getCartItemCount();
    if (itemCount === 0) {
      await addCurrentProduct(form);
    }
    goToCheckout();
  } catch (error) {
    console.error('[more-payment-options]', error);
    trigger.removeAttribute('aria-busy');
    trigger.classList.remove('is-loading');
    window.alert(error instanceof Error ? error.message : 'Unable to continue to checkout.');
  }
}

function initMorePaymentOptions() {
  document.querySelectorAll('[data-more-payment-options]').forEach((el) => {
    if (!(el instanceof HTMLElement) || el.dataset.morePaymentBound) return;
    el.dataset.morePaymentBound = 'true';
    el.addEventListener('click', handleMorePaymentClick);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMorePaymentOptions, { once: true });
} else {
  initMorePaymentOptions();
}

document.addEventListener('shopify:section:load', initMorePaymentOptions);
